// extracted by mini-css-extract-plugin
export default {"buttonwrapper":"buttonwrapper__xsvEB","button":"button__7x67C","icon":"icon__aO8-N","plus":"plus__92EVk","minus":"minus__PkSTx"};